import { message } from 'antd'
import { pick } from 'ramda'
import { fetchUtil as fetch, buildQuery } from 'src/utils/fetch'

export const getAppUsageChart = async (
    startDate:string,
    endDate:string,
    groupBy: string,
    providerCountry:string,
    userName:string,
  ) => {
    try {
      const {data} = await fetch(`/report/app-usage-report/app-usage-chart?groupBy=${groupBy}`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ startDate, endDate,providerCountry,userName }), 

      })
     
      return data
    } catch (e) {
      console.log("Error fetching App Usage Chart!")
    }
  }
  export const getHourlyAppUsageChart = async (
    startDate:string,
    endDate:string,
    groupBy: string,
    providerCountry:string,
    userAccessType: string[],
    aggregateBy:string
  ) => {
    try {
      const {data} = await fetch(`/report/app-usage-report/hourly-usage-chart?groupBy=${groupBy}`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ startDate, endDate,providerCountry,userAccessType,aggregateBy }), 

      })
     
      return data
    } catch (e) {
      console.log("Error fetching App Usage Hourly Chart!")
    }
  }
  export const getGameUsageChart = async (
    startDate:string,
    endDate:string,
    groupBy: string,
    providerCountry:string
  ) => {
    try {
      const {data} = await fetch(`/report/game-usage-report/game-usage-chart?groupBy=${groupBy}`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ startDate, endDate,providerCountry }), 

      })
     
      return data
    } catch (e) {
      console.error("Error fetching App Usage Chart!")
    }
  }
  export const getAppUsageReportMetrics = async (
    startDate:string,
    endDate:string,
    providerCountry:string,
  ) => {
    try {
      const {data} = await fetch("/report/app-usage-report/metrics", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ startDate, endDate,providerCountry }),
      })
     
      return data
    } catch (e) {
      console.error("Error fetching App Usage Report Metrics!")
    }
  }
  export const getGameUsageReportMetrics = async (
    startDate:string,
    endDate:string,
    providerCountry:string,
  ) => {
    try {
      const {data} = await fetch("/report/game-usage-report/metrics", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ startDate, endDate,providerCountry }),
      })
     
      return data
    } catch (e) {
      console.error("Error fetching Game Usage Report Metrics!")
    }
  }
  
  export const getTopTimeSpendingUsers = async (
    startDate: string,
    endDate:string,
    providers:string[],
    size: number,
    page:number
  ) => {
    try {
      const {data} = await fetch(`/report/game-usage-report/top-game-users?page=${page}&pageSize=${size}`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({startDate, endDate, providers}),
      })
      return data
    } catch (e) {
      console.error("Error fetching Top Time Spending Users!")
    }
  }

export const getMostPlayedMazes = async (
    timeline: string,
    providerCountry:string,
    size: number,
    page:number
  ) => {
    try {
      const {data} = await fetch(`/report/maze-report/most-played-mazes?pageSize=${size}&page=${page}`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({timeline,providerCountry}),
      })
      return data
    } catch (e) {
     console.log("Error fetching most played mazes!")
    }
  }
  export const getMostPlayedGames = async (
    startDate: string,
    endDate:string,
    providers:string[],
    size: number,
    page:number
  ) => {
    try {
      const {data} = await fetch(`/report/game-usage-report/most-played-games?pageSize=${size}&page=${page}`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({startDate, endDate, providers}),
      })
      return data
    } catch (e) {
      console.log("Error fetching most played mazes!")
    }
  }
  export const getAppUsageReportHourlyMetrics = async (
    startDate:string,
    endDate:string,
    providerCountry:string,
    userAccessType: string[],
    aggregateBy:string
  ) => {
    try {
      const {data} = await fetch("/report/app-usage-report/hourly-metrics", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ startDate, endDate,providerCountry,userAccessType,aggregateBy }),
      })
     
      return data
    } catch (e) {
      console.error("Error fetching App Usage Report Hourly Metrics!")
    }
  }
  export const getGameUsageReportHourlyMetrics = async (
    startDate:string,
    endDate:string,
    providerCountry:string,
    userAccessType: string[],
    aggregateBy:string
  ) => {
    try {
      const {data} = await fetch("/report/game-usage-report/hourly-metrics", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ startDate, endDate,providerCountry,userAccessType,aggregateBy }),
      })
     
      return data
    } catch (e) {
      console.error("Error fetching Game Usage Report Hourly Metrics!")
    }
  }
  export const getHourlyGameUsageChart = async (
    startDate:string,
    endDate:string,
    groupBy: string,
    providerCountry:string,
    userAccessType: string[],
    aggregateBy:string
  ) => {
    try {
      const {data} = await fetch(`/report/game-usage-report/hourly-usage-chart?groupBy=${groupBy}`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ startDate, endDate,providerCountry,userAccessType,aggregateBy }), 

      })
     
      return data
    } catch (e) {
      console.log("Error fetching Game Usage Hourly Chart!")
    }
  }
  export const getTopSearchKeywords = async (
    startDate: string,
    endDate:string,
    providers:string[],
    searchType:string[],
    size: number,
    page:number
  ) => {
    try {
      const {data} = await fetch(`/report/user-queries-report/top-search-keyword?pageSize=${size}&page=${page}`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({startDate, endDate, providers, searchType}),
      })
      return data
    } catch (e) {
     console.log("Error fetching Top Searched Keywords!")
    }
  }
  export const getTotalUsageMetrics = async (
    startDate: string,
    endDate:string,
    providers:string[],
  ) => {
    try {
      const {data} = await fetch("/report/dashboard/total-usage-metrics", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({startDate, endDate, providers}),
      })
      return data
    } catch (e) {
     console.log("Error fetching Total Usage Metrics!")
    }
  }
  export const getApiCountryParam = (selectedCountryValue, countries) => {
    
    const isAllSelected = selectedCountryValue.includes('ALL') 
    || selectedCountryValue.length === 0;

    if (isAllSelected) {
        return countries
            .filter(option => option.value !== 'ALL')
            .map(option => option.value); 
    } 
    
    return selectedCountryValue;
};
export const getGameUsageOverviewChart = async (
    startDate: string,
    endDate:string,
    providers:string[],
  ) => {
    try {
      const {data} = await fetch("/report/dashboard/game-overview-chart", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({startDate, endDate, providers}),
      })
      return data
    } catch (e) {
     console.log("Error fetching Game Overview Chart!")
    }
  }
  export const getGameUsageHeatmap = async (
    startDate: string,
    endDate:string,
    providers:string[],
    mode:string
  ) => {
    try {
      const {data} = await fetch("/report/dashboard/game-usage-heatmap", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({startDate, endDate, providers,mode}),
      })
      return data
    } catch (e) {
     console.log("Error fetching Game Overview Chart!")
    }
  }
  export const getUserRetention = async (
    startDate: string,
    endDate:string,
    providers:string[],
  ) => {
    try {
      const {data} = await fetch("/report/dashboard/game-usage-retention", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({startDate, endDate, providers}),
      })
      return data
    } catch (e) {
     console.log("Error fetching User Retention!")
    }
  }